import { ReactNode } from 'react';
import { css, cx } from '@linaria/atomic';
import { Text } from '../../..';

const tertiaryTitleStyle = css`
  margin-top: 0;
  margin-right: 0;
  margin-bottom: 0;
  margin-left: 0;
`;

export const ListRowTertiaryTitle = ({
  children,
  as = Text,
  className,
  ...rest
}: {
  as?: any;
  children: ReactNode;
  className?: string;
}) => {
  const Component = as;
  return (
    <Component size='small' className={cx(tertiaryTitleStyle, 'content-column-tertiary-title', className)} {...rest}>
      {children}
    </Component>
  );
};
